import { useTranslation } from 'react-i18next'

import { AlertDropDown, Link, Text } from '@reveni-io/reveni-ui'

const CustomerDashboardLinkAlert = ({ customerDashboardUrl }) => {
  const { t } = useTranslation()

  if (!customerDashboardUrl) return null

  return (
    <AlertDropDown options={{ withoutDropDown: true }} title={t('Estado de tu solicitud')}>
      <Text type="bodySRegular">
        <Link href={customerDashboardUrl} target="_blank" rel="noopener noreferrer">
          <Text type="bodySRegular">{t('Haz click aquí')}</Text>
        </Link>{' '}
        {t(
          'para acceder al detalle de tu solicitud y ver toda la información de seguimiento de tu devolución, estado de los productos, reembolsos, etc.'
        )}
      </Text>
    </AlertDropDown>
  )
}

export default CustomerDashboardLinkAlert
